export var Flow;
(function (Flow) {
    Flow["none"] = "none";
    Flow["keyLocker"] = "key-locker";
    Flow["error"] = "error";
})(Flow || (Flow = {}));
